import { render, staticRenderFns } from "./Report-split.vue?vue&type=template&id=45bd5133"
import script from "./Report-split.vue?vue&type=script&lang=js"
export * from "./Report-split.vue?vue&type=script&lang=js"
import style0 from "./Report-split.vue?vue&type=style&index=0&id=45bd5133&prod&lang=scss"
import style1 from "./Report-split.vue?vue&type=style&index=1&id=45bd5133&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports